
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $d930f65a59d20052$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["3EsVB","index.a5d40b04.js","cPzGy","icons.c14567a0.svg"]'));

const $ef19e442e0cefa4b$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ef19e442e0cefa4b$export$16f4db7dd2abb32a = 15;
const $ef19e442e0cefa4b$export$5feaddb1377b7f5e = 10;
const $ef19e442e0cefa4b$export$7167c830cefcb6b5 = "d4226af1-cc75-4c80-b23c-3a4d2ed69242";
const $ef19e442e0cefa4b$export$564ab7dce2f609c9 = 2.5;



const $305e87f8b1fd70ca$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $305e87f8b1fd70ca$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        const fetchPromise = uploadData ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        const res = await Promise.race([
            fetchPromise,
            $305e87f8b1fd70ca$var$timeout((0, $ef19e442e0cefa4b$export$16f4db7dd2abb32a))
        ]);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        console.error(`${err} \u{1F631}\u{1F631}\u{1F631}\u{1F631}\u{1F631}`);
        throw err;
    }
};


const $0f43de04ce3b058c$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        resultsPerPage: (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e),
        page: 1
    },
    bookmarks: []
};
const $0f43de04ce3b058c$var$createRecipeObject = function(data) {
    const { recipe: recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f43de04ce3b058c$export$b96725c7a035d60b = async function(id) {
    try {
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}${id}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$createRecipeObject(data);
        if ($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id)) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    } catch (err) {
        console.error(`${err} \u{1F631}\u{1F631}\u{1F631}\u{1F631}\u{1F631}`);
        throw err;
    }
};
const $0f43de04ce3b058c$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?search=${query}&key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results = data.data.recipes.map((recipe)=>{
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                image: recipe.image_url,
                ...recipe.key && {
                    key: recipe.key
                }
            };
        });
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = 1;
    } catch (err) {
        console.error(`${err} \u{1F631}\u{1F631}\u{1F631}\u{1F631}\u{1F631}`);
        throw err;
    }
};
const $0f43de04ce3b058c$export$8d7f79465139ab72 = function(page = $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page) {
    $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0f43de04ce3b058c$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $0f43de04ce3b058c$export$ca000e230c0caa3e.search.resultsPerPage;
    return $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f43de04ce3b058c$export$5e23f4642ecad5ea = function(newServings) {
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.ingredients.forEach((ingredient)=>{
        ingredient.quantity = ingredient.quantity * newServings / $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings;
    });
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings = newServings;
};
const $0f43de04ce3b058c$var$persistBookmarks = function() {
    localStorage.setItem("bookmarks", JSON.stringify($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks));
};
const $0f43de04ce3b058c$export$72009cc673d27d80 = function(recipe) {
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.push(recipe);
    if (recipe.id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0f43de04ce3b058c$var$persistBookmarks();
};
const $0f43de04ce3b058c$export$2db69b245b3902c8 = function(id) {
    const index = $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.findIndex((element)=>element.id === id);
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    if (id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0f43de04ce3b058c$var$persistBookmarks();
};
const $0f43de04ce3b058c$var$init = function() {
    const storage = localStorage.getItem("bookmarks");
    if (storage) $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$0f43de04ce3b058c$var$init();
const $0f43de04ce3b058c$var$clearBookmarks = function() {
    localStorage.clear("bookmarks");
};
const $0f43de04ce3b058c$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "").map((ingredient)=>{
            // const ingredientArray = ingredient[1].replaceAll(" ", "").split(",");
            const ingredientArray = ingredient[1].split(",").map((element)=>element.trim());
            if (ingredientArray.length !== 3) throw new Error("Wrong ingredient format! Please use the correct format :)");
            const [quantity, unit, description] = ingredientArray;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`, recipe);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$createRecipeObject(data);
        $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        console.error(err, "\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4");
        throw err;
    }
};


var $c4875025b8f68daf$exports = {};
$c4875025b8f68daf$exports = new URL("icons.c14567a0.svg", import.meta.url).toString();


class $b9930ad8bf2c7fda$export$2e2bcd8739ae039 {
    _data;
    render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const currentElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newElement, i)=>{
            const currentElement = currentElements[i];
            if (!newElement.isEqualNode(currentElement) && newElement.firstChild?.nodeValue.trim() !== "") currentElement.textContent = newElement.textContent;
            if (!newElement.isEqualNode(currentElement)) Array.from(newElement.attributes).forEach((attribute)=>currentElement.setAttribute(attribute.name, attribute.value));
        });
    }
    renderSpinner() {
        const markup = `
      <div class="spinner">
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-loader"></use>
        </svg>
      </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(message = this._errorMessage) {
        const markup = `
    <div class="error">
      <div>
        <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-alert-triangle"></use>
        </svg>
      </div>
      <p>${message}</p>
    </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `
    <div class="message">
      <div>
        <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-smile"></use>
        </svg>
      </div>
      <p>${message}</p>
    </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}



var $47fd1b3d76daecdb$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$47fd1b3d76daecdb$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $47fd1b3d76daecdb$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $47fd1b3d76daecdb$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $47fd1b3d76daecdb$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $47fd1b3d76daecdb$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $47fd1b3d76daecdb$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $47fd1b3d76daecdb$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


class $96ae62c5a8e43877$var$RecipeView extends (0, $b9930ad8bf2c7fda$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".recipe");
    _errorMessage = "Shocking! We couldn't find that recipe. Please try another one!";
    _message = "";
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--update-servings");
            if (!btn) return;
            const { updateTo: updateTo } = btn.dataset;
            if (+updateTo > 0) handler(+updateTo);
        });
    }
    addHandlerAddBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        return `
      <figure class="recipe__fig">
        <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" />
        <h1 class="recipe__title">
          <span>${this._data.title}</span>
        </h1>
      </figure>

      <div class="recipe__details">
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-clock"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
          <span class="recipe__info-text">minutes</span>
        </div>
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-users"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
          <span class="recipe__info-text">servings</span>

          <div class="recipe__info-buttons">
            <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings - 1}">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-minus-circle"></use>
              </svg>
            </button>
            <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings + 1}">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-plus-circle"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="recipe__user-generated ${this._data.key ? "" : "hidden"}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-user"></use>
          </svg>
        </div>
        <button class="btn--round btn--bookmark">
          <svg class="">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
          </svg>
        </button>
      </div>

      <div class="recipe__ingredients">
        <h2 class="heading--2">Recipe ingredients</h2>
        <ul class="recipe__ingredient-list">
          ${this._data.ingredients.map(this._generateMarkupIngredients).join("")}
        </ul>
      </div>

      <div class="recipe__directions">
        <h2 class="heading--2">How to cook it</h2>
        <p class="recipe__directions-text">
          This recipe was carefully designed and tested by
          <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
          directions at their website.
        </p>
        <a
          class="btn--small recipe__btn"
          href="${this._data.sourceUrl}"
          target="_blank"
        >
          <span>Directions</span>
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-arrow-right"></use>
          </svg>
        </a>
      </div>
    `;
    }
    _generateMarkupIngredients(ing) {
        return `
      <li class="recipe__ingredient">
        <svg class="recipe__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($47fd1b3d76daecdb$exports)))(ing.quantity).toString() : ""}</div>
        <div class="recipe__description">
          <span class="recipe__unit">${ing.unit}</span>
          ${ing.description}
        </div>
      </li>
    `;
    }
}
var $96ae62c5a8e43877$export$2e2bcd8739ae039 = new $96ae62c5a8e43877$var$RecipeView();


class $59c24ae67929f662$var$SearchView {
    #parentElement = document.querySelector(".search");
    getQuery() {
        const query = this.#parentElement.querySelector(".search__field").value;
        this.#clearInput();
        return query;
    }
    #clearInput() {
        this.#parentElement.querySelector(".search__field").value = "";
    }
    addHandlerSearch(handler) {
        this.#parentElement.addEventListener("click", function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $59c24ae67929f662$export$2e2bcd8739ae039 = new $59c24ae67929f662$var$SearchView();





class $8b7f4ee14226945a$var$PreviewView extends (0, $b9930ad8bf2c7fda$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
      <li class="preview">
        <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
          <figure class="preview__fig">
            <img src="${this._data.image}" alt="${this._data.title}" />
          </figure>
          <div class="preview__data">
            <h4 class="preview__title">${this._data.title}</h4>
            <p class="preview__publisher">${this._data.publisher}</p>
            <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
              <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-user"></use>
              </svg>
            </div>
          </div>
        </a>
      </li>
    `;
    }
}
var $8b7f4ee14226945a$export$2e2bcd8739ae039 = new $8b7f4ee14226945a$var$PreviewView();



class $9b828d38d31fb13a$var$ResultsView extends (0, $b9930ad8bf2c7fda$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "Shocking! We couldn't find a recipe for that one. Please try another one!";
    _message = "";
    _generateMarkup() {
        return this._data.map((result)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var $9b828d38d31fb13a$export$2e2bcd8739ae039 = new $9b828d38d31fb13a$var$ResultsView();




class $d5cb92833965f6d1$var$PaginationView extends (0, $b9930ad8bf2c7fda$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    addHandlerClick(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generateMarkup() {
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        const currentPage = this._data.page;
        const previousPage = currentPage - 1;
        const nextPage = currentPage + 1;
        if (currentPage === 1 && numPages > 1) return this._generateMarkupPreview(nextPage, true);
        if (currentPage === numPages && numPages > 1) return this._generateMarkupPreview(previousPage);
        if (1 < currentPage < numPages) return this._generateMarkupPreview([
            previousPage,
            nextPage
        ]);
        return "";
    }
    _generateMarkupPreview(page, nextPage = false) {
        const leftMarkup = `
      <button data-goto="${page}" class="btn--inline pagination__btn--prev">
        <svg class="search__icon">
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-arrow-left"></use>
        </svg>
        <span>Page ${page}</span>
      </button>
    `;
        const rightMarkup = `
      <button data-goto="${page}" class="btn--inline pagination__btn--next">
        <span>Page ${page}</span>
        <svg class="search__icon">
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports)))}#icon-arrow-right"></use>
        </svg>
      </button>
    `;
        if (Array.isArray(page)) return `
        <button data-goto="${page[0]}" class="btn--inline pagination__btn--prev">
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-arrow-left"></use>
          </svg>
          <span>Page ${page[0]}</span>
        </button>
        <button data-goto="${page[1]}" class="btn--inline pagination__btn--next">
        <span>Page ${page[1]}</span>
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c4875025b8f68daf$exports))}#icon-arrow-right
          "></use>
        </svg>
        </button>
    `;
        if (nextPage) return rightMarkup;
        return leftMarkup;
    }
}
var $d5cb92833965f6d1$export$2e2bcd8739ae039 = new $d5cb92833965f6d1$var$PaginationView();





class $bb8c26dfe22e3ec0$var$BookmarksView extends (0, $b9930ad8bf2c7fda$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = "No bookmark yet. Find a nice recipe to bookmark!";
    _message = "";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((bookmark)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
}
var $bb8c26dfe22e3ec0$export$2e2bcd8739ae039 = new $bb8c26dfe22e3ec0$var$BookmarksView();




class $69f230dbd0cf4929$var$AddRecipeView extends (0, $b9930ad8bf2c7fda$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".upload");
    _message = "Recipe Successfully Uploaded :D";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnOpen = document.querySelector(".nav__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    toggleWindow() {
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
    }
    _addHandlerShowWindow() {
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
        this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    }
    addHandlerUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArray = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArray);
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $69f230dbd0cf4929$export$2e2bcd8739ae039 = new $69f230dbd0cf4929$var$AddRecipeView();



const $292b382f80842f30$var$controlRecipes = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderSpinner();
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$8d7f79465139ab72());
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        // * 1 . Loading Recipe
        await $0f43de04ce3b058c$export$b96725c7a035d60b(id);
        // * 2. Rendering Recipe data
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        console.error(`${err} \u{1F631}\u{1F631}\u{1F631}\u{1F631}\u{1F631}`);
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderError();
    }
};
const $292b382f80842f30$var$controlSearchResults = async function() {
    try {
        const query = (0, $59c24ae67929f662$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).renderSpinner();
        await $0f43de04ce3b058c$export$202b8e5cb363a0c4(query);
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$8d7f79465139ab72());
        (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
    } catch (err) {
        console.error(err, "\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4");
    }
};
const $292b382f80842f30$var$controlPagination = function(goToPage) {
    (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$8d7f79465139ab72(goToPage));
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
};
const $292b382f80842f30$var$controlServings = function(newServings) {
    $0f43de04ce3b058c$export$5e23f4642ecad5ea(newServings);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
};
const $292b382f80842f30$var$controlUpdateBookmark = function() {
    if (!$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked) $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    else $0f43de04ce3b058c$export$2db69b245b3902c8($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
const $292b382f80842f30$var$controlBookmarks = function() {
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
const $292b382f80842f30$var$controlAddRecipe = async function(newRecipe) {
    try {
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderSpinner();
        await $0f43de04ce3b058c$export$d660c2254e74960d(newRecipe);
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderMessage();
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        window.history.pushState(null, "", `#${$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id}`);
        setTimeout(()=>(0, $69f230dbd0cf4929$export$2e2bcd8739ae039).toggleWindow(), (0, $ef19e442e0cefa4b$export$564ab7dce2f609c9) * 1000);
    } catch (err) {
        console.error(err, "\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4\uD83E\uDEE4");
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderError(err.message);
    }
};
const $292b382f80842f30$var$init = function() {
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlBookmarks);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlRecipes);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerUpdateServings($292b382f80842f30$var$controlServings);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerAddBookmark($292b382f80842f30$var$controlUpdateBookmark);
    (0, $59c24ae67929f662$export$2e2bcd8739ae039).addHandlerSearch($292b382f80842f30$var$controlSearchResults);
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).addHandlerClick($292b382f80842f30$var$controlPagination);
    (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).addHandlerUpload($292b382f80842f30$var$controlAddRecipe);
};
$292b382f80842f30$var$init();


//# sourceMappingURL=index.a5d40b04.js.map
